import React, { useState, useEffect } from 'react';
import styles from './EditLotPricing.module.scss';
import {
	TextField,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	InputAdornment,
	OutlinedInput,
} from '@material-ui/core';
import DatePicker from 'react-datepicker';
import CustomButton from '../../../../layout/customButton/CustomButton';
import ConfirmationComponent from '../../../../confirmation/ConfirmationComponent';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import {
	updateLotPricing,
	updateLotsPricing,
} from '../../../../../api/Siteplan/updateLots.api';
import LotHistory from '../../../history/LotHistory';
import { connect } from 'react-redux';
import { setAlert } from '../../../../../redux/alerts/action';
import { checkPositiveNumber } from '../../../../../utils/validateForm';

const EditLotPricing = (props) => {
	const [availablity, setAvailablity] = useState('');
	const [closingDate, setClosingDate] = useState();
	const [lotSizeType, setLotSizeType] = useState('');
	const [lotPrice, setLotPrice] = useState('');
	const [lotPremium, setLotPremium] = useState('');
	const [lotUpgrade, setLotUpgrade] = useState('');
	const [confirmationModal, setConfirmationModal] = useState(false);

	const { editLotInfo, lotIdArr, closeEditLotsPricingModal, uid, setAlert } =
		props;

	useEffect(() => {
		if (editLotInfo) {
			setLotSizeType(
				editLotInfo.lotSizeType ? editLotInfo.lotSizeType : ''
			);
			setAvailablity(editLotInfo.availability);
			setClosingDate(new Date(editLotInfo.closingDate));
			setLotPrice(editLotInfo.lotPrice);

			let premium = editLotInfo?.pricing?.reduce((prev, curr) => {
				if (curr.name === 'Lot Premium') {
					return curr.price + prev;
				} else {
					return prev;
				}
			}, 0);
			setLotPremium(premium ? premium : '');

			let upgrade = editLotInfo?.pricing?.reduce((prev, curr) => {
				if (curr.name === 'WOB') {
					return curr.price + prev;
				} else {
					return prev;
				}
			}, 0);
			setLotUpgrade(upgrade ? upgrade : '');
		} else {
			setLotSizeType('');
			setAvailablity('');
			setClosingDate();
			setLotPrice('');
			setLotPremium('');
			setLotUpgrade('');
		}
	}, [editLotInfo]);

	const handleAvailabilityChange = (e) => {
		setAvailablity(e.target.value);
	};

	const handleLotSizeChange = (e) => {
		setLotSizeType(e.target.value);
	};

	const handleLotPremium = (e) => {
		let value = e.target.value;
		if (checkPositiveNumber(value)) setLotPremium(value);
	};

	const handleLotUpgrade = (e) => {
		let value = e.target.value;
		if (checkPositiveNumber(value)) setLotUpgrade(e.target.value);
	};

	const handleLotPrice = (e) => {
		let value = e.target.value;
		if (checkPositiveNumber(value)) setLotPrice(e.target.value);
	};

	const closeConfirmationModal = () => {
		setConfirmationModal(false);
	};

	const openConfirmationModal = () => {
		setConfirmationModal(true);
	};

	const handleEditLot = () => {
		// validate the price value entered
		if (isNaN(lotPrice)) {
			setAlert('warning', 'Please enter valid price value.');
			return;
		}

		if (isNaN(lotPremium)) {
			setAlert('warning', 'Please enter valid premium value.');
			return;
		}

		if (isNaN(lotUpgrade)) {
			setAlert('warning', 'Please enter valid upgrade value.');
			return;
		}

		console.log('front availability', availablity);

		var tempLotPrice = lotPrice; // issue here
		var tempLotPremium = lotPremium;
		var tempLotUpgrade = lotUpgrade;

		if (editLotInfo) {
			// edit single lot
			console.log('front availability', availablity);
			updateLotPricing(
				editLotInfo.lot,
				{
					lotSizeType: lotSizeType,
					lotAvailability: availablity,
					closingDate: closingDate.toISOString().substring(0, 10),
					lotPrice: Number(tempLotPrice),
					lotPremiumPrice: Number(tempLotPremium),
					lotUpgradePrice: Number(tempLotUpgrade),
				},
				uid
			);
			closeEditLotsPricingModal();
		} else {
			// edit batch lots
			console.log('front availability', availablity);
			updateLotsPricing(
				lotIdArr,
				{
					lotSizeType: lotSizeType,
					lotAvailability: availablity,
					closingDate: closingDate?.toISOString().substring(0, 10),
					lotPrice: Number(tempLotPrice),
					lotPremiumPrice: Number(tempLotPremium),
					lotUpgradePrice: Number(tempLotUpgrade),
				},
				uid
			);
			closeEditLotsPricingModal();
		}
	};

	const CustomDatePicker = ({ value, onClick }) => (
		<TextField
			className={styles.custom_date_picker}
			onClick={onClick}
			value={value}
			variant='outlined'
			label='Closing Date'
			InputProps={{
				endAdornment: (
					<InputAdornment position='end'>
						<CalendarTodayIcon />
					</InputAdornment>
				),
			}}
		/>
	);

	const confirmationButtonList = [
		{
			name: 'cancel',
			action: () => {
				closeConfirmationModal();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Save changes',
			action: () => {
				handleEditLot();
				closeConfirmationModal();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<div className={styles.edit_lot}>
			<div className={styles.history}>
				{editLotInfo ? (
					<LotHistory
						lotId={editLotInfo.lot}
						lotPrice={editLotInfo?.lotPrice}
					/>
				) : (
					<LotHistory lotIdArr={lotIdArr} />
				)}
			</div>
			<div className={styles.lot}>
				<h2 className={styles.lot_title}>Edit Lot Pricing</h2>
				<div className={styles.lot_edit_form}>
					<FormControl variant='outlined'>
						<InputLabel id='lot-size'>Size</InputLabel>
						<Select
							labelId='lot-size'
							value={lotSizeType}
							onChange={handleLotSizeChange}
							label='Size'
						>
							<MenuItem value='50'>50'</MenuItem>
							<MenuItem value='70'>70'</MenuItem>
						</Select>
					</FormControl>
					<TextField
						variant='outlined'
						label='Grade'
						value={lotPremium}
						onChange={handleLotPremium}
					/>
					<TextField
						variant='outlined'
						label='Upgrade'
						value={lotUpgrade}
						onChange={handleLotUpgrade}
					/>
					<TextField
						variant='outlined'
						label='Premium'
						value={lotPrice}
						onChange={handleLotPrice}
					/>
					<FormControl variant='outlined'>
						<InputLabel id='lot-availability'>
							Lot Availability
						</InputLabel>
						<Select
							labelId='lot-availability'
							value={availablity}
							onChange={handleAvailabilityChange}
							label='Lot Availability'
						>
							<MenuItem value='soldout'>Sold Out</MenuItem>
							<MenuItem value='pending'>Pending</MenuItem>
							<MenuItem value='available'>Available</MenuItem>
							<MenuItem value='hold'>Hold</MenuItem>
						</Select>
					</FormControl>
					<DatePicker
						customInput={<CustomDatePicker />}
						minDate={new Date()}
						selected={closingDate}
						onChange={(date) => setClosingDate(date)}
						dateFormat='MMMM d, yyyy'
					/>
					<div className={styles.apply_btn}>
						<CustomButton
							width={166}
							height={42}
							onClick={openConfirmationModal}
						>
							Apply
						</CustomButton>
					</div>
				</div>
			</div>
			<ConfirmationComponent
				open={confirmationModal}
				handleClose={closeConfirmationModal}
				title='Are you sure	you want to save this changes on pricing?'
				buttonList={confirmationButtonList}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	uid: state.signIn.uid,
	confirmation: state.confirmation,
});
export default connect(mapStateToProps, {
	setAlert,
})(EditLotPricing);
